import { areObjectsEquivalent } from '../../../../utils/equivalence-utils';
import { areDiscountItemPricesEquivalent } from './are-discount-item-prices-equivalent';
import { isDiscountItemPrice } from './item-price-utils';
export const areItemPricesEquivalent = (itemPrices) => {
    const allAreDiscountPrices = itemPrices.every(isDiscountItemPrice);
    if (allAreDiscountPrices)
        return areDiscountItemPricesEquivalent(itemPrices);
    const someAreDiscountPrices = itemPrices.some(isDiscountItemPrice);
    if (someAreDiscountPrices)
        return false;
    const hasSameItemPrice = itemPrices.every(itemPrice => areObjectsEquivalent(itemPrice.price, itemPrices[0].price));
    return hasSameItemPrice;
};
